// Imports
import ViewTitlepage from "./ViewTitlepage.vue";
import ViewTitlePagePeople from "./ViewTitlePagePeople";
import ViewHome from "./ViewHome.vue";
import ViewOutput from "./ViewOutput.vue";
import ViewMethodStudySetting from "./ViewMethodStudySetting.vue";
import ViewMethodEligibilityCriteria from "./ViewMethodEligibilityCriteria.vue";
import ViewMethodInterventions from "./ViewMethodInterventions.vue";
import ViewMethodOutcomes from "./ViewMethodOutcomes.vue";
import ViewMethodParticipantTimeline from "./ViewMethodParticipantTimeline.vue";
import ViewMethodSampleSize from "./ViewMethodSampleSize.vue";
import ViewMethodRecruitment from "./ViewMethodRecruitment.vue";
import ViewMethodAssignmentOfInterventions from "./ViewMethodAssignmentOfInterventions.vue";
import ViewMethodDataCollection from "./ViewMethodDataCollection.vue";
import ViewMethodMonitoring from "./ViewMethodMonitoring.vue";
//import ViewMethodEthicsAndDissemination from "./ViewMethodEthicsAndDissemination.vue";
import ViewMethodStudyInformation from "./ViewMethodStudyInformation.vue";
import ViewMethodResearchPlan from "./ViewMethodResearchPlan.vue";

import ViewMethodEthicsAndConsent from "./ViewMethodEthicsAndConsent.vue";
import ViewMethodDissemination from "./ViewMethodDissemination.vue";
import ViewMethodContributions from "../methods-wizard/ViewMethodContributions.vue";

// The path for deepstream, where the bulk of the information is kept (e.g. `methods/${projectId}`)
const deepstreamPath = "trial";

// The routes array for the router
const routes = [
	{ name: "home", path: "", component: ViewHome },
	{ path: "/", component: ViewHome },
	{
		name: "titlepage",
		path: "/titlepage",
		component: ViewTitlepage
	},
	{
		name: "investigators",
		path: "/investigators",
		component: ViewTitlePagePeople
	},
	{
		name: "rs-plan",
		path: "/rs-plan",
		component: ViewMethodResearchPlan
	},
	{
		name: "study-informaiton",
		path: "/method/studyInformation",
		component: ViewMethodStudyInformation
	},
	{
		path: "/method/contributions",
		component: ViewMethodContributions
	},
	{
		name: "study-setting",
		path: "/method/study-setting",
		component: ViewMethodStudySetting
	},
	{
		name: "eligibility-criteria",
		path: "/method/eligibility-criteria",
		component: ViewMethodEligibilityCriteria
	},
	{
		name: "interventions",
		path: "/method/interventions",
		component: ViewMethodInterventions
	},
	{
		name: "outcomes",
		path: "/method/outcomes",
		component: ViewMethodOutcomes
	},
	{
		name: "participant-timeline",
		path: "/method/participantTimeline",
		component: ViewMethodParticipantTimeline
	},
	{
		name: "sample-size",
		path: "/method/sampleSize",
		component: ViewMethodSampleSize
	},
	{
		name: "recruitment",
		path: "/method/recruitment",
		component: ViewMethodRecruitment
	},
	{
		name: "assignment-of-interventions",
		path: "/method/assignmentOfInterventions",
		component: ViewMethodAssignmentOfInterventions
	},
	{
		name: "data-collection",
		path: "/method/dataCollection",
		component: ViewMethodDataCollection
	},
	{
		name: "monitoring",
		path: "/method/monitoring",
		component: ViewMethodMonitoring
	},
	{
		name: "ethics-and-consent",
		path: "/method/ethicsAndConsent",
		component: ViewMethodEthicsAndConsent
	},
	{
		name: "dissemination",
		path: "/method/dissemination",
		component: ViewMethodDissemination
	},
	/*{
		name: "ethics-and-dissemination",
		path: "/method/ethicsAndDissemination",
		component: ViewMethodEthicsAndDissemination
	},*/
	{
		path: "/output",
		component: ViewOutput
	}
];

// The data required for the project
const data = {
	titlepage: {
		title: "",
		titleshort: "",
		year: 0,
		//people
		authors: [""],
		acknowledgements: [""]
	},
	studySetting: {
		settings: [],
		regions: []
	},
	eligibilityCriteria: {
		ages: [],
		ageBracket: "",
		sexes: [],
		conditions: [],
		severity: [],
		others: [],
		othersExcluded: [],
		baselineMeasurments: []
	},
	interventions: {
		interventions: [{ name: "", materials: "", instructions: "" }],
		control: [{ name: "", materials: "", instructions: "" }],
		discontinued: [],
		adherenceMaintained: [],
		adherenceMonitored: [],
		allInstructions: "",
		prohibitedInterventions: ""
	},
	outcomes: {
		primary: [{ name: "", assessed: "", time: "" }],
		secondary: [{ name: "", assessed: "", time: "" }],
		adverse: [{ name: "", assessed: "", time: "" }],
		clinicalRelevance: ""
	},
	participantTimeline: {
		schematic: true
	},
	sampleSize: {
		trialType: "",
		trialTypeOther: "",
		studyPower: "",
		studyPowerOther: "",
		levelOfSignificance: "",
		levelOfSignificanceOther: "",
		sampleSize: "",
		effectSize: "",
		participantDropOuts: "",
		//new added
		trialDesign: []
	},
	recruitment: {
		recruitment: []
	},
	assignmentOfInterventions: {
		ratioRandomization: [],
		sequenceGen: [],
		concealment: "",
		blindedPeople: [],
		blindedMethod: "",
		unblinding: [],
		//new added
		mechanism: [],
		concealSteps: ""
	},
	dataCollection: {
		dataManagement: "",
		dataQuality: "",
		furtherDetails: [],
		primaryMeasure: "",
		secondaryMeasure: "",
		adverseEventMeasure: "",
		subgroupAnalysis: "",
		subgroupComparison: "",
		subgroupMethod: "",
		efficacyComparisons: [],
		efficacyPopulation: "",
		safetyPopulation: "",
		missingData: [],
		missingDataWhy: "",
		sensitivityAnalyses: ""
	},
	monitoring: {
		isCommittee: true,
		committeeDetails: "",
		committeeReporting: "",
		committeeComposition: "",
		committeeLink: "",
		committeeNotSetUpReasons: "",
		isInterimAnalysis: true,
		interimAnalysisTimePoints: "",
		interimResultsAvailable: [],
		earlyStop: "",
		finalDecisionOnTermination: [],
		interimNotConductedReasons: "",
		adverseEventsMonitored: "",
		trialAuditing: ""
	},
	ethicsAndDissemination: {
		approval: "",
		protocol: "",
		consent: "",
		confidentiality: "",
		declaration: "",
		access: "",
		care: "",
		dissemination: "",
		//new added
		responsiblePerson: [],
		relatedDoc: "",
		guidelines: "",
		plans: ""
	},
	//new page
	studyInformation: {
		trialRegistered: "",
		trialRegistNumber: "",
		protocolVersion: "",
		protocolDate: null,
		supports: "",
		sponsors: [""],
		sponsorRole: "",
		sponsorInfo: "",
		reDescription: "",
		researchObjectives: "",
		bioSpecimens: ""
	},
	researchplan: {
		planTable: {
			headers: [
				{ name: "progress", label: "Done" },
				{ name: "tasks", label: "Task" },
				{
					name: "toolDescription",
					label: "Description"
				},
				{ name: "toolLink", label: "Tool" },
				{
					name: "peopleInvolved",
					label: "People"
				},
				{
					name: "notes",
					label: "Notes"
				}
			],
			rows: [
				{
					progress: false,
					tasks: "Write the protocol",
					toolDescription:
						"Drafting the study protocol using the trial wizard tool ideally in a group format",
					toolLink: [
						{
							name: "Trial Wizard",
							link: "/titlepage"
						}
					],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Write grant application",
					toolDescription:
						"For trials that require (additional) external funding to make them viable",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Drafting participant information brochures",
					toolDescription:
						"Information on the trial to be given to all prospective trial participants",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Drafting informed consent forms",
					toolDescription:
						"Forms needed to be signed by all prospsective trial participants before enrolment",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Design data collection forms and instruments",
					toolDescription:
						"Paper forms or computerised equivalents. Choice of scales (e.g. QoL)",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Protocol review and approval",
					toolDescription:
						"Obtaining approvals from regulatory bodies, institutional review boards (IRBs), and ethics committees",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Trial registration",
					toolDescription:
						"Register the trial on a suitable platform such as clinicaltrials.gov",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Statistical analysis plan (SAP)",
					toolDescription:
						"Separate document to the protocol where the specific details of the statistical analysis to be performed are described",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Design randomisation system",
					toolDescription:
						"Design the procedure required to randomise eligible and consenting patients to treatment groups",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Drug/device packaging and labelling",
					toolDescription: "For drug or device trials",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks:
						"Design system for monitoring drug/device shipping, restocking, returns",
					toolDescription: "For drug or device trials",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Setup of trial management committee",
					toolDescription:
						"Committee for overseeing and managing various aspects of the clinical trial",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Site selection",
					toolDescription:
						"Identifying and selecting appropriate study sites and investigators.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Employment/recruitment of staff",
					toolDescription:
						"Additional people required to help run the clinical trial",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Design site management system",
					toolDescription:
						"Monitor site and investigator qualification, participation, ethics approvals, regulatory approvals, recruitment progress etc",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Investigator meetings",
					toolDescription:
						"Meetings to train investigators and study staff on protocol procedures, data collection, and safety reporting",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Regulatory submissions",
					toolDescription:
						"Submitting regulatory documents, such as investigational new drug (IND) applications or clinical trial applications (CTAs), to regulatory authorities for approval",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Setup of safety data monitoring committee",
					toolDescription:
						"Committee for monitoring participant safety and evaluating interim analyses that could include stopping rules due to efficacy, safety, or futility.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Setup of outcome adjudication committee",
					toolDescription:
						"Some RCTs require clinical outcomes to be independently assessed by experts",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Recruitment strategies",
					toolDescription:
						"Developing and implementing strategies to recruit eligible participants into the trial",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Set up data entry system and data quality control checks",
					toolDescription:
						"Central data entry and forms management, or distributed data entry at sites",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Informed consent process",
					toolDescription:
						"Obtaining informed consent from participants before enrolment",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Randomisation",
					toolDescription:
						"Randomising consenting participants to treatment group",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Study monitoring",
					toolDescription:
						"Monitoring study progress, data quality, and adherence to protocol procedures through site visits, remote monitoring, and data review",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Safety monitoring",
					toolDescription:
						"Monitoring participant safety and adverse events throughout the trial, including serious adverse event (SAE) reporting and safety reviews",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Data collection and management",
					toolDescription:
						"Collecting, recording, and managing study data according to protocol requirements and regulatory standards.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Study drug/device management",
					toolDescription:
						"Managing the distribution, storage, dispensing, and accountability of study drugs or devices.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Finalising data in preparation for analysis",
					toolDescription:
						"Ensuring the integrity and completeness of the data",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Outcome adjudication",
					toolDescription:
						"Independent group adjudication of clinical outcomes",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Interim analyses",
					toolDescription:
						"Conducting interim analyses for safety or efficacy endpoints, if applicable",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Interim reports to ethics committees",
					toolDescription: "Usually required annually",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Final analysis",
					toolDescription:
						"Performing the final analysis of study data as per the SAP",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Manuscript preparation",
					toolDescription: "Writing the Trial manuscript for publication.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Publication",
					toolDescription:
						"Submitting the manuscript to peer-reviewed journals for publication and responding to reviewer comments as needed",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Add results to trial register",
					toolDescription:
						"Most trial registers allow you to report the aggregate trial results",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Dissemination of findings",
					toolDescription:
						"Presentation of trial findings at meetings (local, national, international)",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Regulatory compliance",
					toolDescription:
						"Ensuring documentation of compliance with regulatory requirements, including GCP guidelines.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Documentation",
					toolDescription:
						"Maintaining accurate and complete trial documentation",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Study closeout visits",
					toolDescription:
						"Conducting site closeout visits to ensure completion of study activities and documentation",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Final reports to ethics committees",
					toolDescription:
						"Write the final reports required by ethics committees according to their specifications",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Archiving",
					toolDescription:
						"Archiving study documents, data, and materials according to regulatory requirements and sponsor policies",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				}
			]
		}
	}
};

// The menu array which is used for the sidebar
const getMenu = () => [
	{
		header: true,
		title: "Trial-Wizard",
		hiddenOnCollapse: true
	},
	{
		title: "Title Page",
		icon: "pi pi-file",
		href: `/titlepage`
	},
	{
		title: "Investigators",
		icon: "pi pi-file",
		href: `/investigators`
	},
	{
		header: true,
		title: "Trial Protocol",
		hiddenOnCollapse: true
	},
	{
		title: "Study Setting",
		icon: "pi pi-file",
		href: `/method/study-setting`
	},
	{
		title: "Eligibility Criteria",
		icon: "pi pi-file",
		href: `/method/eligibility-criteria`
	},
	{
		title: "Interventions",
		icon: "pi pi-file",
		href: `/method/interventions`
	},
	{
		title: "Outcomes",
		icon: "pi pi-file",
		href: `/method/outcomes`
	},
	{
		title: "Participant Timeline",
		icon: "pi pi-file",
		href: `/method/participantTimeline`
	},
	{
		title: "Sample Size",
		icon: "pi pi-file",
		href: `/method/sampleSize`
	},
	{
		title: "Recruitment",
		icon: "pi pi-file",
		href: `/method/recruitment`
	},
	{
		title: "Assignment of Interventions",
		icon: "pi pi-file",
		href: `/method/assignmentOfInterventions`
	},
	{
		title: "Data Collection, Management and Analysis",
		icon: "pi pi-file",
		href: `/method/dataCollection`
	},
	{
		title: "Monitoring",
		icon: "pi pi-file",
		href: `/method/monitoring`
	},
	{
		title: "Ethics and Consent",
		icon: "pi pi-file",
		href: `/method/ethicsAndConsent`
	},
	{
		title: "Dissemination",
		icon: "pi pi-file",
		href: `/method/dissemination`
	},
	/*{
		title: "Ethics and Dissemination",
		icon: "pi pi-file",
		href: `/method/ethicsAndDissemination`
	},*/
	{
		title: "Study Information",
		icon: "pi pi-file",
		href: `/method/studyInformation`
	},
	{
		title: "Contributions",
		icon: "pi pi-chart-line",
		href: `/method/contributions`
	},
	{
		header: true,
		title: "Output",
		hiddenOnCollapse: true
	},
	{
		title: "Trial Plan",
		icon: "pi pi-list",
		href: `/rs-plan`
	},
	{
		title: "Output",
		icon: "pi pi-download",
		href: `/output`
	}
];

export { deepstreamPath, routes, data, getMenu };
